import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

/**
 * Returns true if this item is currently in the process of being created.
 * We prevent operations such as opening the peek or compose when an item
 * is being created.
 * @param item The calendar item
 */
export default function isNewCalendarItem(item: CalendarEvent) {
    if (item && item.ItemId && item.ItemId.Id) {
        let tempItemId = item.ClientSeriesId;
        return (
            tempItemId &&
            (item.IsRecurring ? tempItemId == item.InstanceKey : tempItemId == item.ItemId.Id)
        );
    } else {
        return true;
    }
}
